import { Abi, Address, erc20Abi } from "viem"

import { IS_MEZO_MAINNET } from "../constants/network"

type GetERC20TokenArtifactOptions = {
  mainnetAddress: Address
  testnetAddress: Address
  abi?: Abi
}

function getERC20TokenArtifact({
  mainnetAddress,
  testnetAddress,
  abi = erc20Abi,
}: GetERC20TokenArtifactOptions) {
  return {
    address: IS_MEZO_MAINNET ? mainnetAddress : testnetAddress,
    abi,
  }
}

type GetBridgeableERC20TokenArtifact = GetERC20TokenArtifactOptions & {
  mezoMainnetAddress: Address
  mezoTestnetAddress: Address
}

function getBridgeableERC20TokenArtifact({
  abi = erc20Abi,
  mainnetAddress,
  testnetAddress,
  mezoMainnetAddress,
  mezoTestnetAddress,
}: GetBridgeableERC20TokenArtifact) {
  const { address } = getERC20TokenArtifact({
    abi,
    mainnetAddress,
    testnetAddress,
  })

  const { address: mezoBridgedAssetAddress } = getERC20TokenArtifact({
    abi,
    mainnetAddress: mezoMainnetAddress,
    testnetAddress: mezoTestnetAddress,
  })

  return {
    abi,
    address,
    mezoBridgedAssetAddress,
  }
}

export default {
  getERC20TokenArtifact,
  getBridgeableERC20TokenArtifact,
}
